import router from '@/router/index'
import moment from 'moment'
import cloneDeep from 'lodash/cloneDeep'
import { Message, Spin } from 'iview'
import indexDb from '@/libs/IndexedDB.js'
import config from './config'
import xss from 'xss'

import store from '@/store/index'
import { setWaterMark } from '@/libs/watermark'
import MenuMethods from '@/libs/menu.js'
import DomMessage from '@/libs/domMessage'
import { getCurrentUser } from '@/api/hr-user2'
import { getEnumListByCls, getDictListByDicType } from '@/api/data2'

import { previewUrl, ossPreviewUrl } from '@/api/document-sack'
import CryptoJS from 'crypto-js'
let timeC = 3600
const messageOnce = new DomMessage()
let Base64 = require('js-base64').Base64
let getFileH = (filename) => {
  let index1 = filename.lastIndexOf('.')
  let index2 = filename.length
  let result = filename.substring(index1, index2)// 后缀名
  return result
}

let findkeyIndex = (arr, key, val) => { // 查找数组下标值
  if (arr) {
    if (key) {
      return arr.findIndex((mitem) => mitem[key] == val)
    } else {
      return arr.findIndex((mitem) => mitem == val)
    }
  } else {
    return -1
  }
}
/**
 *
 * @param {*} resUrl  下载文件链接url
 * @param {*} filename  下载文件名称
 */
// 下载文件
let dowonldUrlFile = (resUrl, filename) => {
  let fileUrl = resUrl
  // 下载方法
  function downloadWithBlob(url, filename) {
    fetch(url).then(res => res.blob().then(blob => {
      let a = document.createElement('a')
      let url = window.URL.createObjectURL(blob)
      a.href = url
      a.download = filename
      a.click()
      window.URL.revokeObjectURL(url)
    }))
  }
  downloadWithBlob(fileUrl, filename)
}
let changeTImeStamp = (val) => { // 日期转时间戳
  return moment(val).valueOf()
}
let changeTimeDate = (val, type = 'YYYY-MM-DD') => { // 时间戳转日期
  let numTest = new RegExp('[0-9]+')
  let values = val ? String(val) : ''
  if (values.indexOf('-') == -1 && values) {
    return moment(Number(values)).format(type)
  } else {
    return val || ''
  }
}
// 导出文件
let downloadFile = (mehtodsName, params, filename = '未命名文件') => {
  mehtodsName(params, { responseType: 'blob' }).then(async res => {
    const { data, headers } = res
    if (typeof data === 'object') {
      if (!!data.type && !!data.size) {
        // 返回的是数据流 -- 继续往下走
      } else {
        // 需要处理异常 -- 需要抛出异常信息
        if (data.code == 0) {
          // data.msg 异常信息
          Message.error(data.msg)
        } else {
          // 没有数据流
          Message.error('下载失败')
        }
        return
      }
    } else {
      Message.error('服务端错误')
      // 需要处理异常 -- 不是文件流，没有办法下载
      return
    }
    if (headers._x_fw_rest_code == 32008) {
      let derive = res.data
      let text = await (new Response(derive)).text()
      Message.error(JSON.parse(text).msg)
      return
    }
    const link = document.createElement('a')
    // let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
    let blob = new Blob([res.data])
    console.log(res)
    // let blob = new Blob([res.data], { type: 'text/plain;charset=utf-8' })
    link.style.display = 'none'
    link.href = URL.createObjectURL(blob)
    let name = headers['content-disposition']
    let aa = name.split(';')
    let bb = aa[1].split('=')

    if (bb[1].startsWith('{')) {
      let cc = decodeURIComponent(JSON.parse(bb[1]))
      if (cc.indexOf('"') > -1) {
        cc = cc.replace(/"/g, '').trim()
      }
      // let cc = decodeURIComponent(bb[1])
      // link.download = cc || filename // 下载的文件名
      // link.download = cc || filename // 下载的文件名
      link.download = makeFileName(cc, filename) // 下载的文件名
    } else {
      let cc = decodeURIComponent(bb[1])
      if (cc.indexOf('"') > -1) {
        cc = cc.replace(/"/g, '').trim()
      }
      // link.download = cc || filename // 下载的文件名
      link.download = makeFileName(cc, filename) // 下载的文件名
    }
    document.body.appendChild(link)
    link.click()
    URL.revokeObjectURL(link.href) // 释放URL 对象
    document.body.removeChild(link)
  }).catch(async e => {
    console.log(e)
    if (e && e.response && e.response.data) {
      let data = e.response.data
      if (data && e.request.responseType === 'blob') {
        let resData = JSON.parse(await data.text())
        Message.error(resData.msg)
        return
      }
    }
    console.log(e)
    Message.error('下载失败')
  })
}

let makeFileName = (ccName, fileName = '未命名文件') => {
  // debugger
  if ((fileName == undefined || fileName == null || fileName == '' || fileName == '未命名文件') && ccName) {
    return ccName
  }

  if (fileName.indexOf('.') > -1) {
    return fileName
  }

  let ccNameArr = (ccName || '').split('.')

  let suffix = ccNameArr.length > 1 ? ccNameArr[ccNameArr.length - 1] : ''
  if (suffix) {
    suffix = '.' + suffix
  }
  return fileName + suffix
}

const requestResponse = (res, val, url) => {
  let queue = {}
  if (val == 'request') {
    let config = res
    if (sessionStorage.getItem('token')) {
      config.headers['accesstoken'] = sessionStorage.getItem('token')
    }
    let urlName = JSON.parse(JSON.stringify(config.url))
    // config.url = spiltUrl(config.url, 'xx_api') // 更改前缀

    let comP = isPamars(config)
    // let comP = ''
    // debugger
    if (config.url.indexOf('?') == -1) {
      config.url = config.url.split('?')[0] + comP
    }
    // 添加全局的loading...
    if (!config.data) {
      config.data = {}
    }
    if (!(config.data instanceof Array)) {
      let objEmpty = store.state.menuName.frontParams
      let frontParams = objEmpty ? (Object.prototype.isPrototypeOf(objEmpty) && Object.keys(objEmpty).length === 0 ? {} : JSON.parse(objEmpty)) : {}
      Object.assign(config.data, frontParams)
    }
    // config.data = { ...JSON.parse(store.state.frontParams || '{}'), ...config.data }
    if (!Object.keys(queue).length && !config.data.hasOwnProperty('isLoading') && config.data.loadingOff) {
      // if (!Object.keys(this.queue).length && !config.data.hasOwnProperty('isLoading')) {
      Spin.show() // 不建议开启，因为界面不友好
      Spin.show({
        render: (h) => {
          return h('div', [
            h('Icon', {
              'class': 'demo-spin-icon-load',
              props: {
                type: 'ios-loading',
                size: 35
              }
            }),
            h('div', 'Loading')
          ])
        }
      })
    }
    queue[url] = true
    return config
  } else if (val == 'response') {
    const { data, status, headers, config } = res
    if (headers && headers.accesstoken) {
      store.commit('set_token', headers.accesstoken)
    }

    // 存储枚举数据
    let strUrl = config.url
    if (strUrl.split('?')[0] == '/api/api/getEnumListByCls') {
      if (data.data && ((Array.isArray(data.data) && data.data.length > 0) || (!Array.isArray(data.data) && Object.keys(data.data) > 0))) {
        let emData = JSON.parse(sessionStorage.getItem('enumerationData')) || {}
        let parmarsObj = JSON.parse(config.data)
        emData[`${parmarsObj.enumClassName}`] = data.data
        store.commit('setEnumerationData', emData)
      }
    } else if (strUrl.split('?')[0] == '/api/api/getDictListByDicType') {
      if (data.data && ((Array.isArray(data.data) && data.data.length > 0) || (!Array.isArray(data.data) && Object.keys(data.data) > 0))) {
        let emData = JSON.parse(sessionStorage.getItem('dictypeData')) || {}
        let parmarsObj = JSON.parse(config.data)

        // console.log('dictypeData',data.data)
        emData[`${parmarsObj.typeCode}`] = data.data
        store.commit('setDictypeData', emData)
      }
    }

    if (data && typeof data === 'object' && !(data instanceof Blob) && data.code != 0 && data.code != 9898) {
      // Message.error(data.msg)
      // messageOnce.error((data.msg || '').replace(/\n/g, '<br/>'))
    }
    if (data.code == 4) { // 认证失败  重新登录
      store.commit('del_uInfo')
      store.commit('del_token')
      setTimeout(() => {
        router.push({ name: 'login', query: {} })
      }, 800)
    } else if (data.code == 18) {
      store.commit('changeShowTime', 0)
      const mask_bg = document.querySelector('#mask_bg')
      mask_bg || lockBg()
      lock()
    }
    return { data, status, headers }
  }
}
let isPamars = (params) => {
  let lengths = 0
  for (const key in params.data) {
    if (isObject(params.data[key])) { // 值不能为对象
      lengths = 2
    }
    lengths++
  }
  let parmarsData = params.data
  let comP = ''
  let keyIndex = 1
  if (lengths == 1) {
    if (params.url.substr(params.url.length - 1, 1) == '?') {
      for (let key in parmarsData) {
        comP += `&${key}=${parmarsData[key]}`
      }
    } else {
      for (let key in parmarsData) {
        if (keyIndex == 1) {
          comP += `?${key}=${parmarsData[key]}`
        } else {
          comP += `&${key}=${parmarsData[key]}`
        }
        keyIndex++
      }
    }
  }
  return comP
}
const isObject = (obj) => {
  if (obj && obj instanceof Object) {
    return true
  } else {
    return false
  }
}
let copyArr = (obj) => {
  var newobj = obj.constructor === Array ? [] : {}
  if (typeof obj !== 'object') {
    return
  }
  for (var i in obj) {
    newobj[i] = typeof obj[i] === 'object' ? copyArr(obj[i]) : obj[i]
  }
  return newobj
}

let formatMethods = (val, type) => { // 验证表单方法
  let reg = /^[1-9]\d*$/ // 正整数
  let regFloat = /^[0-9]\d*(\.\d{1,2})?$/ // 大于0 的数字 11.22
  let off = false
  if (val) {
    if (type == 'number') {
      off = !reg.test(val) // 不符合规则
    } else if (type == 'float') {
      off = !regFloat.test(val) // 不符合规则
    }
  }
  return off
}
let openFile = (data) => { // 查看文件
  previewUrl({ token: data.data }).then(res => {
    const { code, data, msg } = res.data
    if (code === 0) {
      let url = encodeURIComponent(Base64.encodeURL(res.data.data)) // 要预览文件的访问地址
      //   window.open('http://127.0.0.1:8012/priview?url=' + encodeURIComponent(Base64.encode(url)))
      window.open(`/preview/onlinePreview?url=${url}`)
    } else {
      Message.error(data.msg)
    }
  })
}

// 表单验证
// ruleValidate  一级菜单
/**
 *
 * @param {*} mehtodsName 方法名
 * @param {*} params 参数
 * @param {*} childrenparams 二级参数  回调 (类型数据 ['contacts'])
 * @param {*} fn 回调函数
 *
 * @typedef {object} fn 配置
 */
let validComForm = (mehtodsName, params, childrenparams, fn, name) => {
  mehtodsName(params).then(res => {
    const { data, headers } = res
    let validObj = {}
    let validChildrenObj = {}
    let arrKeyRight = {}
    childrenparams.map((item, index) => {
      arrKeyRight[item] = []
    })
    if (data.code == 14 && data['data']) {
      let reqFieldErrorList = res.data.data.reqFieldErrorList || []
      let reqFormatErrorList = res.data.data.reqFormatErrorList || []
      let arrReq = reqFieldErrorList.concat(reqFormatErrorList)
      let ruleValidate = arrReq
      ruleValidate.map((item, index) => {
        if (item.fields.length == 1) {
          validObj[item.fieldStr] = [{ required: true, message: item.message }]
        }
        if (item.fields.length == 3 && childrenparams.length > 0) { // 含有子集
          childrenparams.map((keyName, index2) => {
            if (keyName == item.fields[0].field) { // 若传入参数名等于 后端返回的参数名
              let childrenName = item.fields[2].field
              !arrKeyRight[keyName][item.fields[1].index] && (arrKeyRight[keyName][item.fields[1].index] = {})
              arrKeyRight[keyName][item.fields[1].index][childrenName] = [{ required: true, message: item.message, offRequire: true }]
            }
          })
        }
      })
      fn(data, { validObj: validObj, validChildrenObj: validChildrenObj, arrKeyRight: arrKeyRight })
    } else {
      fn(data)
    }
  }).catch(async e => {
    console.log('验证失败', e)
  })
}

let Trim = (str) => { // 去除前后空格
  str = String(str)
  return str ? str.replace(/(^\s*)|(\s*$)/g, '') : str || ''
}
let changePrice = (str = 0, type, num = 2) => { // 转换金额格式  或百分比格式
  let val = Trim(str) || ''
  val = Number(val)
  if (type == '%' && val) {
    val = (val * 100)
    val = Number(val).toFixed(num)
    val = `${val}%`
  } else if (type == 'price' && val) {
    val = comdify(delcommafy(val))
  } else if (val) {
    val = Number(val).toFixed(num).replace(/(\d)(?=(\d{3})+\.)/g, '$1,') || 0
  }
  return val
}
/**
 *
 * @param {*} val
 * @param {*} type
 * @returns
 * 无函数   {code: 1,name: 1}
 * 有函数   {code: 1,name: 1,fn=(()={})}
 */
let deepCopy = (val, type) => { // 深拷贝
  return cloneDeep(val)
  // if (!type) { // 无函数
  //   return JSON.parse(JSON.stringify(val))
  // } else { // 有函数
  //   return Object.assign(type || {}, val)
  // }
}
const MoneyTest = /((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/
// 金额添加千分位
const comdify = function (n) {
  if (!n) return n
  let str = n.split('.')
  let re = /\d{1,3}(?=(\d{3})+$)/g
  let n1 = str[0].replace(re, '$&,')
  // return str.length > 1 && str[1] ? `${n1}.${str[1]}` : `${n1}.00`
  return str.length > 1 && str[1] ? `${n1}.${str[1]}` : `${n1}`
}
// 去除千分位中的‘，'
const delcommafy = function (num) {
  if (!num) return num
  num = num.toString()
  num = num.replace(/,/gi, '')
  return num
}
const newsGoPage = (obj) => { // 消息中心跳转
  if (obj.businessData.sceneCode == 'S0000006') { // 流程开始转消息
    const { href } = router.resolve({ name: `pending-trial`, params: { msgItem: JSON.stringify(obj.businessData) } })
    window.open(href, '_blank')
  } else if (obj.businessData.sceneCode == 'S0000007') { // 流程流转完成消息
    const { href } = router.resolve({ name: `apply`, params: { msgItem: JSON.stringify(obj.businessData) } })
    window.open(href, '_blank')
  } else if (obj.businessData.sceneCode == 'S0000008') { // 未填写日报提醒
    const { href } = router.resolve({ name: `my-daily`, params: { msgItem: JSON.stringify(obj.businessData) } })
    window.open(href, '_blank')
  } else if (obj.businessData.sceneCode == 'S0000009') { // 初始化用户密码
    // router.push({ name: 'home-news' ,params: {}})
  } else if (obj.businessData.sceneCode == 'S0000010') { // 流程状态变更通知
    const { href } = router.resolve({ name: `apply`, params: { msgItem: JSON.stringify(obj.businessData) } })
    window.open(href, '_blank')
  } else if (obj.businessData.sceneCode == 'S0000011') { // 周计划填写提醒
    const { href } = router.resolve({ name: `weekly-management-myPlan`, params: { msgItem: JSON.stringify(obj.businessData) } })
    window.open(href, '_blank')
  } else if (obj.businessData.sceneCode == 'S0000012') { // 周计划总结填写提醒
    const { href } = router.resolve({ name: `weekly-management-myPlan`, params: { msgItem: JSON.stringify(obj.businessData) } })
    window.open(href, '_blank')
  } else if (obj.businessData.sceneCode == 'S0000013') { // 周计划总结填写提醒
    const { href } = router.resolve({ name: `weekly-management-memberPlan`, params: { msgItem: JSON.stringify(obj.businessData) } })
    window.open(href, '_blank')
  } else if (obj.businessData.sceneCode == 'S0000014') { // 周计划总结填写提醒
    const { href } = router.resolve({ name: `weekly-management-myPlan`, params: { msgItem: JSON.stringify(obj.businessData) } })
    window.open(href, '_blank')
  }
}
/**
 *
 * @param {*} key 查询参数名称
 * @returns
 */
let comGetData = (key) => {
  return new Promise(resolve => {
    indexDb.selectData('luoData', 'person', key, (res) => {
      if (res && res.status == 'success') {
        resolve(res)
      }
    })
  })
}
let comSetData = async (key, val) => {
  if (!val) return
  let data = await comGetData(key)
  let newData = data.data || []
  newData.push(val)
  indexDb.insertData('luoData', 'person', key, newData, (res) => { console.log(res) })
}

// 获取图片显示路径
const getImgUrl = (fileUrl) => {
  return new Promise((resolve, reject) => {
    ossPreviewUrl({ path: fileUrl }).then(res => {
      resolve(res)
    })
  })
}
const getDateTime = (val) => {
  let obj = {}
  if (val) {
    obj['year'] = val.substring(0, 4)
    obj['month'] = val.substring(5, 7)
    obj['day'] = val.substring(8, 10)
  }
  return obj
}
const getTimeText = (val) => {
  let time = val / 1000
  if (time != null && time != '') {
    if (time > 60 && time < 60 * 60) {
      // time = parseInt(time / 60.0) + '分钟' + parseInt((parseFloat(time / 60.0) - parseInt(time / 60.0)) * 60) + '秒'
      time = parseInt(time / 60.0) + '分钟' + (time - parseInt(time / 60) * 60) + '秒'
    } else if (time >= 60 * 60 && time < 60 * 60 * 24) {
      let h = parseInt(time / 3600)
      let m = parseInt((time - h * 3600) / 60)
      let s = time - m * 60 - h * 3600
      time = `${h}小时${m}分钟${s}秒`
      //     time = parseInt(time / 3600.0) + '小时' + parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) + '分钟' +
      // parseInt((parseFloat((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) -
      // parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60)) * 60) + '秒'
    } else if (time >= 60 * 60 * 24) {
      let d = parseInt(time / 86400)
      let h = parseInt((time - d * 86400) / 3600)
      let m = parseInt((time - d * 86400 - h * 3600) / 60)
      let s = time - m * 60 - h * 3600 - d * 86400
      time = `${d}天${h}小时${m}分钟${s}秒`
      //     time = parseInt(time / 3600.0 / 24) + '天' + parseInt((parseFloat(time / 3600.0 / 24) -
      // parseInt(time / 3600.0 / 24)) * 24) + '小时' + parseInt((parseFloat(time / 3600.0) -
      // parseInt(time / 3600.0)) * 60) + '分钟' +
      // parseInt((parseFloat((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) -
      // parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60)) * 60) + '秒'
    } else {
      time = parseInt(time) + '秒'
    }
  }
  return time
}
const getComUserInfo = (val) => {
  getCurrentUser({ loadingOff: true }).then(async (res, dat) => {
    const { data } = res
    if (data.code == 0) {
      setTimeout(() => {
        setWaterMark('', 'name')
      }, 500)
      await getCurrentTenant(val)
      await getMenuListByCurrentUser(data, [], val) // 根据用户id获取菜单-当前用户
      // this.$router.push({
      //   name: 'dash-board'
      // })
    }
  })
}
const getCurrentTenant = async (val) => { // 获取当前用户得租户信息
  let tenantInfo = {
    id: 1
  }
  store.commit('set_tenantInfo', tenantInfo)

  // queryCurrentTenant({}).then((res, dat) => {
  //   const { data } = res
  //   if (data.code == 0) {
  //     let tenantInfo = data.data
  //     console.log('后去', tenantInfo)
  //     store.commit('set_tenantInfo', tenantInfo)
  //     // if (val == 'new') {
  //     //   location.reload()
  //     // }
  //   }
  // })
}
const getMenuListByCurrentUser = async (data, menuList, val, sso) => { // 根据用户id获取菜单-当前用户
  if (menuList && menuList.length > 0 && (val && val != 'new')) {
  } else if (sessionStorage.getItem('leftMenu')) {
    if (sessionStorage.getItem('leftMenu')) {
      menuList = JSON.parse(sessionStorage.getItem('leftMenu')) ? JSON.parse(sessionStorage.getItem('leftMenu')) : await MenuMethods.getMenu()
    } else {
      menuList = await MenuMethods.getMenu()
    }
  } else {
    menuList = await MenuMethods.getMenu()
  }
  let loginFlag = false
  for (let menu of menuList) {
    // let offIndex = menu.frontPath ? findkeyIndex(config.routerList, '', menu.frontPath):findkeyIndex(config.routerList, '', menu.name)
    let offIndex = findkeyIndex(config.routerList, '', menu.name)
    if (offIndex <= -1) {
      // sso 单点登录跳转特定首页
      if (sso) {
        if (sso == 'material') {
          Message.success('登录成功')
          loginFlag = true
          if (data) {
            store.commit('set_uInfo', data.data)
          }
          router.push({ name: 'sso-material' })
          Spin.hide()
          break
        }
        break
      }
      if (menu.children && menu.children.length > 0) {
        Message.success('登录成功')
        loginFlag = true
        if (data) {
          store.commit('set_uInfo', data.data)
        }
        router.push({ name: menu.children[0].frontPath })
        Spin.hide()
        break
      } else {
        Message.success('登录成功')
        loginFlag = true
        if (data) {
          store.commit('set_uInfo', data.data)
        }
        router.push({ name: menu.frontPath })
        Spin.hide()
        break
      }
    }
  }
  if (!loginFlag) {
    Message.error('登录失败,该用户暂无菜单权限')
    router.replace({ path: '/login' })
    sessionStorage.clear()
    // localStorage.clear()
    Spin.hide()
  } else {
    if (!menuList || menuList.length == 0) {
      Message.error('登录失败,该用户暂无菜单权限')
      router.replace({ path: '/login' })
      sessionStorage.clear()
      // localStorage.clear()
      Spin.hide()
      return
    }
  }
  if (val == 'new') {
    // setTimeout(() => {
    window.location.reload()
    // }, 1000);
  }
}

const goPowerMenu = async (menuList) => {
  if (!menuList || menuList.length <= 0) {
    menuList = JSON.parse(sessionStorage.getItem('leftMenu')) ? JSON.parse(sessionStorage.getItem('leftMenu')) : await MenuMethods.getMenu()
  }
  for (let menu of menuList) {
    if (findkeyIndex(config.routerList, '', menu.name) <= -1) {
      if (menu.children && menu.children.length > 0) {
        router.push({ name: menu.children[0].frontPath })
        break
      } else {
        router.push({ name: menu.frontPath })
        break
      }
    }
  }
}
/**
 * 前端 对树进行过滤
 * @param {*} oldList 后端传过来的数据列表
 * @param {*} searchkey 搜索查询的键值名称
 * @param {*} searchValue 搜索内容
 * @param {*} hasOnlyChildren 1: 过滤子集元素只有包含关键字的项（默认）2：不过滤子级数据
 * @param {*} highlightAll 1: 高亮父、级字（默认） 2：只高亮子级  ****暂时废弃
 *
 * @returns
 */
// filterTreeData(this.oldList,'orgName',this.serchValue)
let filterTreeData = (oldList, searchkey, searchValue, hasOnlyChildren = 1, highlightAll = 1) => {
  let treeList = JSON.parse(JSON.stringify(oldList))
  return new Promise(resolve => {
    let newTree = [] // 过滤之后的树
    if (searchValue == '') {
      newTree = treeList
      resolve(newTree)
    } else {
      let ids = []
      let map = new Map()
      var resultList = []
      let filterList = function (lists) { // 循环过滤
        let haschildren = function (obj) {
          return obj.children !== undefined && obj.children.length > 0
        }
        lists.forEach(item => {
          ids.push(item.id)
          let content = item[searchkey] == undefined ? '' : item[searchkey]
          if (content.indexOf(searchValue) > -1) { // 模糊搜索
            var tmpList = resultList
            for (let id of ids) {
              let hit = false
              for (let resultItem of tmpList) {
                if (resultItem.id == id) {
                  tmpList = resultItem.children
                  hit = true
                  break
                }
              }
              if (!hit) {
                var tmpItem
                if (id === item.id) {
                  tmpItem = item
                } else {
                  tmpItem = map.get(id)
                }
                let newItem = tmpItem

                newItem['expand'] = true
                newItem['isExpand'] = true
                let childrenArr = []
                newItem['children'] = tmpItem.children
                if (newItem['children'] && newItem['children'].length > 0) {
                  newItem['children'] = newItem['children'].map((item2, index2) => {
                    let { val, off } = brightenKeyword(item2[searchkey], searchValue)
                    // item2[searchkey] = val
                    if (off) {
                      childrenArr.push(item2)
                    }
                    return item2
                  })
                }
                if (hasOnlyChildren == 1) {
                  newItem['children'] = childrenArr
                }
                if (highlightAll == 1) {
                  // let { val, off } = brightenKeyword(newItem[searchkey], searchValue)
                  // newItem[searchkey] = val
                }
                tmpList.push(newItem)
                tmpList = newItem.children ? newItem.children : []
              }
            }
          }
          if (haschildren(item)) {
            map.set(item.id, item)
            filterList(item.children, searchValue)
          }
          ids.pop()
        })
      }
      filterList(treeList)

      resultList = reelect(resultList, searchkey, searchValue)

      newTree = resultList
      // console.log('返回数据',resultList)

      resolve(newTree)
    }
  })
}
let reelect = (tree = [], searchkey, searchValue) => {
  let arr = []
  if (!!tree && tree.length !== 0) {
    tree.forEach(item => {
      let obj = {}
      item['expand'] = true
      item['isExpand'] = true
      let { val, off } = brightenKeyword(item[searchkey], searchValue)
      item[searchkey] = val
      obj = item
      obj.children = reelect(item.children, searchkey, searchValue)
      arr.push(obj)
    })
  }
  // this.treeData = arr

  return arr
}
let brightenKeyword = (val, keyword) => {
  let off = false
  if (keyword.length > 0) {
    // let keywordArr = keyword.split("");
    let keywordArr = [keyword]
    val = val + ''
    keywordArr.forEach(item => {
      if (val.indexOf(item) !== -1 && item !== '') {
        off = true
        val = val.replace(
          new RegExp(item, 'g'),
          '<font color="#f75353">' + item + '</font>'
        )
      }
    })
    return { val, off }
  } else {
    return { val, off }
  }
}
/**
 *
 * @param {*} dataKey 枚举名称
 * @param {*} code   code 值
 */
const getTypeData = async (dataKey, code) => {
  return new Promise((resolve, reject) => {
    let data = { enumClassName: dataKey }
    let list = []
    let kuData = sessionStorage.getItem('enumerationData') ? JSON.parse(sessionStorage.getItem('enumerationData')) : {}
    let showName = ''
    if (kuData.hasOwnProperty(`${data.enumClassName}`)) {
      list = kuData[`${data.enumClassName}`]
      if (JSON.stringify(code)) {
        if (list && list.length > 0) {
          let offIndex1 = findkeyIndex(list, 'code', code)
          showName = offIndex1 > -1 ? list[offIndex1].name : ''
          resolve(showName)
        } else {
          resolve(showName)
        }
      } else {
        resolve(list)
      }
    } else {
      getEnumListByCls({ enumClassName: data.enumClassName }).then((res) => {
        const { data } = res
        // 处理数组
        if (data.code == 0) {
          list = data.data
          if (JSON.stringify(code)) {
            if (list && list.length > 0) {
              let offIndex1 = findkeyIndex(list, 'code', code)
              showName = offIndex1 > -1 ? list[offIndex1].name : ''
              resolve(showName)
            } else {
              resolve(showName)
            }
          } else {
            resolve(list)
          }
        }
      })
    }
  })
}
/**
 *
 * @param {*} dataKey 枚举名称
 * @param {*} code   code 值
 */
const getDictypeData = async (dataKey, code = '') => {
  return new Promise((resolve, reject) => {
    let data = { typeCode: dataKey }
    let list = []
    let kuData = sessionStorage.getItem('dictypeData') ? JSON.parse(sessionStorage.getItem('dictypeData')) : {}
    let showName = ''
    if (kuData.hasOwnProperty(`${data.typeCode}`)) {
      list = kuData[`${data.typeCode}`]
      if (code != '') {
        if (list && list.length > 0) {
          let offIndex1 = findkeyIndex(list, 'code', code)
          showName = offIndex1 > -1 ? list[offIndex1].name : ''
          resolve(showName)
        } else {
          resolve(showName)
        }
      } else {
        resolve(list)
      }
    } else {
      getDictListByDicType({ typeCode: data.typeCode }).then((res) => {
        const { data } = res
        // 处理数组
        if (data.code == 0) {
          list = data.data
          if (code != '') {
            if (list && list.length > 0) {
              let offIndex1 = findkeyIndex(list, 'code', code)
              showName = offIndex1 > -1 ? list[offIndex1].name : ''
              resolve(showName)
            } else {
              resolve(showName)
            }
          } else {
            resolve(list)
          }
        }
      })
    }
  })
}
const FilterXssHtml = (val) => {
  const option = {
    onIgnoreTagAttr: function (tag, name, value, isWhiteAttr) {
      if (['style', 'class'].includes(name)) {
        return `${name}="${xss.escapeAttrValue(value)}"`
      }
    }
  }
  const myxss = new xss.FilterXSS(option)
  val = myxss.process(val)
  return val
}
const setKey = (val1, val2) => {
  // let onOff = comConfig.onOff
  // let serverPubKey = comConfig.serverPubKey
  let onOff = val1
  let serverPubKey = val2
  // let onOff = true
  // let serverPubKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCh5QRBjoUOOwcdSAuHup8GuC19szzV7MY9skA2riqMZOWYa9Mj59Utl6SG9ZM1sJJLtAzMMDJIuRCZrka0KYlH_CP1WfyZC9jbhurL7Vzg6-BFI865CKvGkgr8p6TCaKoPOSLy9s1IRzhsSebFBNcKep97lHQGXswzpfDmJtpXfQIDAQAB'
  let aesKey
  if (onOff) {
    var iv = CryptoJS.lib.WordArray.random(16)
    // aesKey = CryptoJS.enc.Base64.stringify(iv)
    if (window.sessionStorage.getItem('aesKey')) {
      aesKey = window.sessionStorage.getItem('aesKey')
    } else {
      aesKey = CryptoJS.lib.WordArray.random(16)
      aesKey = CryptoJS.enc.Base64.stringify(aesKey)
      window.sessionStorage.setItem('aesKey', aesKey)
      // alert('村支'+aesKey)
    }
  }
}
// 查看数组中是否含有符合条件的数据
const checkCodeArr = (arr = []) => {
  if (arr && arr.length <= 0) return false
  let index = 0
  arr.map((item) => {
    if (MenuMethods.checkCodeShow(item)) {
      index += 1
    }
  })
  return index > 0
}
const GetUrlParam = (paraName, urlV) => {
  // let url = document.location.toString();
  let url = urlV || window.location.href
  let arrObj = url.split('?')
  if (arrObj.length > 1) {
    let arrPara = arrObj[1].split('&')
    let arr
    for (let i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split('=')

      if (arr != null && arr[0] == paraName) {
        return arr[1]
      }
    }
    return ''
  } else {
    return ''
  }
}
const getFblWidth = (width = 0) => {
  let newWidth = width
  // const m = detectZoom()
  let widthPm = (window.screen.width * window.devicePixelRatio).toFixed(2)
  // let bhScale = (widthPm / 1920).toFixed(0) + 0.5
  let bhScale = 1

  if (window.screen.width >= 3840) {
    bhScale = 2.2
  } else if (window.screen.width >= 2048) {
    bhScale = 1.8
  }
  // console.log('屏幕1', window.screen.width, window.devicePixelRatio)
  // console.log('屏幕2', widthPm, bhScale, m)
  newWidth = bhScale * width
  return newWidth
}

const changeSheetJson = (vald, type) => {
  let arr = cloneDeep(vald)
  let datas = []
  if (type == 'arr') {
    datas = arr
  } else {
    datas = arr.data
  }
  datas = datas.map((item) => {
    for (let i = 0; i < item.data.length; i++) {
      for (let j = 0; j < item.data[i].length; j++) {
        if (item.data[i][j] && (item.data[i][j].ph || item.data[i][j].form)) {
          delete item.data[i][j].ph
          item.data[i][j].bg = '#ffffff'
          if (item.data[i][j].v == '' || item.data[i][j].v == null || item.data[i][j].v == undefined || JSON.stringify(item.data[i][j].v) == '{}') {
            item.data[i][j].m = ''
            delete item.data[i][j].ct
            delete item.data[i][j].plHtml
            delete item.data[i][j].ct
          }
          // item.data[i][j].v = ''
        }
      }
    }
    if (item.images) {
      let arr = [
        'https://placeholder.idcd.com/600x300?text=600x300',
        'https://static.juyouqi.net//jyq_pc/dynamic-form/imgs/company-seal.png',
        'https://static.juyouqi.net//jyq_pc/dynamic-form/imgs/company-seal.png  ',
        'https://static.juyouqi.net//jyq_pc/dynamic-form/imgs/person-seal.png'
      ]
      for (const key in item.images) {
        if (item.images[key] && arr.includes(item.images[key].src)) {
          delete item.images[key]
        }
      }
    }
    return item
  })
  if (type == 'arr') {
    arr = datas
  } else {
    arr.data = datas
  }
  return arr
}
export default {
  getFileH,
  dowonldUrlFile,
  findkeyIndex,
  changeTImeStamp,
  changeTimeDate,
  downloadFile,
  requestResponse,
  checkCodeArr,
  copyArr,
  GetUrlParam,
  formatMethods,
  openFile,
  validComForm,
  Trim,
  changePrice,
  deepCopy,
  comGetData,
  comSetData,
  newsGoPage,
  getImgUrl,
  getDateTime,
  getTimeText,
  getComUserInfo,
  getMenuListByCurrentUser,
  goPowerMenu,
  getCurrentTenant,
  filterTreeData,
  getTypeData,
  getDictypeData,
  FilterXssHtml,
  setKey,
  getFblWidth,
  changeSheetJson
}
